<template>
  <div>
    <b-row>
      <b-col md="12">
        <h4>Opportunity and Student Dashboard</h4>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col md="12">
        <b-button variant="primary" class="mx-1" :to="{name: 'opportunities'}" exact>View Active Opportunities</b-button>
        <b-button variant="primary" class="mx-1" :to="{name: 'applicationProgress'}" exact>View Student Applications</b-button>
        <b-button variant="primary" class="mx-1" :to="{name: 'opportunityAdd'}" exact>Add Opportunity</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <widget heading="Semester Totals">
        <opportunity-semester-summary/>
        </widget>
      </b-col>
      <b-col>
        <widget heading="Incomplete Opportunities">
        <items-per-term v-if="incompleteOpportunities" :items="incompleteOpportunities"/>
        </widget>
        </b-col>
        
      <b-col>
        <widget heading="Student Opportunity Timeline">
          <student-opportunity-timeline/>
        </widget>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <widget heading="Site Popularity">
        <site-popularity />
        </widget>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <widget heading="Approved Students">
          <approved-students />
        </widget>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import opportunityReportsApi from "../../api/opportunityReporting";
import itemsPerTerm from "../../components/dashboard/items-per-term";
import opportunitySemesterSummary from "./opportunity-semester-summary";
import studentOpportunityTimeline from "./student-opportunity-timeline";
import widget from "../widget";
import SitePopularity from "./site-popularity";
import approvedStudents from "./approved-students";
export default {
  data() {
    return {
      semesterTotals: null,
      incompleteOpportunities: null,
      sitePopularity: null,
    };
  },

  components: {
    opportunitySemesterSummary,
    itemsPerTerm,
    studentOpportunityTimeline,
    widget,
    SitePopularity,
    approvedStudents,
  },

  created() {
    opportunityReportsApi.getIncompleteOpportunities().then((response) => {
      this.incompleteOpportunities = response.data;
    });
  },
};
</script>

<style scoped>
/* .btn-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.btn-primary:hover {
  background-color: #a02048;
} */
</style>
